export const EQUIPMENT_STATUS_CUSTOMER_CODES = new Set<string>(['car', 'ggn']);
export const TRIPS_REPORT_CUSTOMER_CODES = new Set<string>(['car', 'ggn']);
export const TRIP_REPORT_SENSOR_CUSTOMER_CODES = new Set<string>([
  'car',
  'ggn',
]);
export const MATERIAL_MOVEMENT_REPORT_CUSTOMER_CODES = new Set<string>([
  'car',
  'ggn',
]);
export const MATERIAL_MOVEMENT_BY_DUMP_CUSTOMER_CODES = new Set<string>([
  'car',
  'ggn',
]);

export const SHOW_ONLY_ENGINE_HOUR_SUMMARY_CUSTOMER_CODES = new Set<string>([
  'myn',
  'buz',
]);
export const SHOW_ONLY_4DAY_ROTATION_CUSTOMER_CODES = new Set<string>(['drn']);
export const SHOW_ONLY_SHIFT_WISE_CUSTOMER_CODES = new Set<string>(['drn']);
export type CrewReportType = 'shift' | 'rotation' | 'engine_hour_summary';
export type ReportType = CrewReportType | 'equipment_status';

export function isReportEnabledForCustomer(
  customerCode: string | null | undefined,
  reportType: CrewReportType
): boolean {
  if (!customerCode) return false;
  switch (reportType) {
    case 'engine_hour_summary':
      return SHOW_ONLY_ENGINE_HOUR_SUMMARY_CUSTOMER_CODES.has(customerCode);
    case 'rotation':
      return SHOW_ONLY_4DAY_ROTATION_CUSTOMER_CODES.has(customerCode);
    case 'shift':
      return SHOW_ONLY_SHIFT_WISE_CUSTOMER_CODES.has(customerCode);
    default:
      return false;
  }
}
